import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { App } from '@capacitor/app';

const CreditosView = () => {
  const navigate = useNavigate();
  const [appVersion, setAppVersion] = useState('2.0.0');

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Detectar plataforma y versión
    const detectVersion = async () => {
      try {
        // Si es app nativa de Capacitor, leer versión real del sistema
        if (window.Capacitor?.isNativePlatform?.()) {
          const info = await App.getInfo();
          return info.version; // Lee la versión real: iOS 2.5, Android 2.8, etc.
        }
        
        // Si es PWA o web
        return '2.0.0';
      } catch (error) {
        console.error('Error detectando versión:', error);
        return '2.0.0';
      }
    };
    
    detectVersion().then(version => setAppVersion(version));
  }, []);

  return (
    <div className="app-container">
      <div className="content-container">
        
        {/* ===== FIX iOS: Fondo extendido que cubre la safe area ===== */}
        <div 
          className="absolute inset-x-0 top-0"
          style={{
            background: 'linear-gradient(to bottom, #c82318 0%, #c82318 15%, #a01916 100%)',
            height: 'calc(70px + env(safe-area-inset-top))',
            marginTop: 'calc(-1 * env(safe-area-inset-top))',
            zIndex: 1
          }}
        />
        
        {/* Header con navegación */}
        <div 
          className="relative text-white px-5"
          style={{
            paddingTop: 'max(env(safe-area-inset-top), 15px)',
            paddingBottom: '15px',
            minHeight: 'calc(70px + env(safe-area-inset-top))',
            zIndex: 10,
            background: 'linear-gradient(to bottom, #c82318 0%, #c82318 15%, #a01916 100%)'
          }}
        >
          <div className="flex items-center justify-between" style={{ paddingTop: '15px' }}>
            <button
              onClick={() => navigate(-1)}
              className="w-9 h-9 rounded-xl flex items-center justify-center bg-white bg-opacity-20 backdrop-blur-sm text-white hover:bg-opacity-30 transition-all"
            >
              ←
            </button>
            
            <h1 className="text-lg font-semibold text-center flex-1 mx-4">
              Créditos
            </h1>
            
            <div className="w-9"></div> {/* Espaciador para centrar el título */}
          </div>
        </div>

        {/* Contenido */}
        <div className="px-5 py-8 bg-white" style={{ minHeight: '100vh' }}>
          <div className="prose max-w-none space-y-6 text-gray-700 leading-relaxed">
            
            <div className="text-center mb-8">
              <img 
                src="/logo192.png" 
                alt="Logo Agustinos" 
                className="w-24 h-24 mx-auto mb-4"
              />
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Agustinos
              </h2>
              <p className="text-gray-600">
                Versión {appVersion}
              </p>
            </div>

            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">
                  Desarrollado por
                </h3>
                <p>
                  <strong>Provincia San Juan de Sahagún</strong><br />
                  Orden de San Agustín de España
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">
                  Contenido y coordinación
                </h3>
                <p>
                  Equipo de Pastoral Provincial<br />
                  Provincia San Juan de Sahagún
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">
                  Contacto
                </h3>
                <p>
                  <strong>Email:</strong>{' '}
                  <a 
                    href="mailto:pastoralapp@agustinos.es" 
                    className="text-red-600 hover:underline"
                  >
                    pastoralapp@agustinos.es
                  </a>
                </p>
                <p className="mt-2">
                  <strong>Web:</strong>{' '}
                  <a 
                    href="https://agustinos.es" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-red-600 hover:underline"
                  >
                    agustinos.es
                  </a>
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">
                  Agradecimientos
                </h3>
                <p>
                  A todos los colaboradores, autores y miembros de la comunidad agustiniana 
                  que han contribuido con su tiempo, conocimiento y dedicación para hacer 
                  posible esta aplicación.
                </p>
              </div>

              <div className="pt-6 border-t border-gray-200">
                <p className="text-sm text-gray-600 text-center">
                  © {new Date().getFullYear()} Provincia San Juan de Sahagún<br />
                  Orden de San Agustín de España<br />
                  Todos los derechos reservados
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Padding bottom para espacio */}
        <div style={{ height: '40px' }}></div>
      </div>
    </div>
  );
};

export default CreditosView;

